var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExerciseReading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_725_5112)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27322 4.41477C1 6.1672 1 8.66703 1 13.6667V16.3333C1 21.333 1 23.8328 2.27322 25.5852C2.68442 26.1512 3.18213 26.6489 3.7481 27.0601C5.50054 28.3333 8.00036 28.3333 13 28.3333C17.9996 28.3333 20.4995 28.3333 22.2519 27.0601C22.8179 26.6489 23.3156 26.1512 23.7268 25.5852C25 23.8328 25 21.333 25 16.3333V13.6667C25 8.66703 25 6.1672 23.7268 4.41477C23.3156 3.8488 22.8179 3.35108 22.2519 2.93989C20.4995 1.66667 17.9996 1.66667 13 1.66667C8.00036 1.66667 5.50054 1.66667 3.7481 2.93989C3.18213 3.35108 2.68442 3.8488 2.27322 4.41477Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.86871 4.12087C1.15985 5.09653 0.825823 6.25765 0.662061 7.76916C0.499995 9.26502 0.499997 11.162 0.5 13.6354V13.6667V16.3333V16.3646C0.499997 18.838 0.499995 20.735 0.662061 22.2308C0.825823 23.7424 1.15985 24.9035 1.86871 25.8791L2.27322 25.5852L1.86871 25.8791C2.31075 26.4875 2.84579 27.0226 3.45421 27.4646C4.42986 28.1735 5.59098 28.5075 7.10249 28.6713C8.59835 28.8333 10.4954 28.8333 12.9688 28.8333H13H13.0312C15.5046 28.8333 17.4016 28.8333 18.8975 28.6713C20.409 28.5075 21.5701 28.1735 22.5458 27.4646C23.1542 27.0226 23.6893 26.4875 24.1313 25.8791C24.8401 24.9035 25.1742 23.7424 25.3379 22.2308C25.5 20.735 25.5 18.838 25.5 16.3646V16.3333V13.6667V13.6354C25.5 11.162 25.5 9.26502 25.3379 7.76916C25.1742 6.25765 24.8401 5.09653 24.1313 4.12087C23.6893 3.51246 23.1542 2.97742 22.5458 2.53538C21.5701 1.82652 20.409 1.49249 18.8975 1.32873C17.4016 1.16666 15.5046 1.16666 13.0312 1.16667H13H12.9688C10.4954 1.16666 8.59835 1.16666 7.10249 1.32873C5.59098 1.49249 4.42986 1.82652 3.45421 2.53538C2.84579 2.97742 2.31075 3.51246 1.86871 4.12087Z",
    stroke: "url(#paint0_linear_725_5112)",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_725_5112)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66675 8.66667C7.11446 8.66667 6.66675 9.11438 6.66675 9.66667C6.66675 10.219 7.11446 10.6667 7.66675 10.6667H18.3334C18.8857 10.6667 19.3334 10.219 19.3334 9.66667C19.3334 9.11438 18.8857 8.66667 18.3334 8.66667H7.66675ZM7.66675 14C7.11446 14 6.66675 14.4477 6.66675 15C6.66675 15.5523 7.11446 16 7.66675 16H18.3334C18.8857 16 19.3334 15.5523 19.3334 15C19.3334 14.4477 18.8857 14 18.3334 14H7.66675ZM7.66675 19.3333C7.11446 19.3333 6.66675 19.781 6.66675 20.3333C6.66675 20.8856 7.11446 21.3333 7.66675 21.3333H18.3334C18.8857 21.3333 19.3334 20.8856 19.3334 20.3333C19.3334 19.781 18.8857 19.3333 18.3334 19.3333H7.66675Z",
    fill: "url(#paint1_linear_725_5112)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_725_5112",
    x: -24,
    y: -23.3333,
    width: 74,
    height: 76.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_725_5112"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_725_5112",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_725_5112",
    x: -17.3333,
    y: -15.3333,
    width: 60.6667,
    height: 60.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_725_5112"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_725_5112",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_725_5112",
    x1: 1,
    y1: 1.66667,
    x2: 27.53,
    y2: 25.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_725_5112",
    x1: 13.1067,
    y1: 24.0319,
    x2: 30.5888,
    y2: 6.89519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseReading);
export default __webpack_public_path__ + "static/media/exercise-reading.f40daa8a93263ed906b3be015cade478.svg";
export { ForwardRef as ReactComponent };